module.exports = __webpack_public_path__ + "static/media/All-Star-Kids.c16aa25f.png";